import { Button } from '@material-ui/core'
import React, { useCallback } from 'react'
import { changeLocale as changeLocaleAction, translate, UPDATE } from 'react-admin'
import { connect } from 'react-redux'
import { useUser } from './auth/client'
import dataProvider from './dataProvider'

const LocaleSwitcher = (props) => {
  const { changeLocale, locale, translate } = props

  const { user } = useUser()
  const userSub = user?.['sub']

  const updateLocale = useCallback(
    (lngcode) => {
      if (userSub) {
        dataProvider(UPDATE, 'meta', { id: userSub, data: { language: lngcode } })
      }
    },
    [userSub],
  )

  const switchLng = useCallback(
    (code) => {
      changeLocale(code)
      updateLocale(code)
    },
    [changeLocale, updateLocale],
  )

  return (
    <div>
      <div
        style={{
          display: 'flex',
          flex: 1,
          justifyContent: 'flex-end',
          alignItems: 'flex-end',
          color: 'black',
          padding: 10,
        }}
      >
        {translate('main.language', { _: 'Untranslated Language' })}
        <br />
      </div>
      <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end', alignItems: 'flex-end', padding: 10 }}>
        <Button
          style={{ backgroundColor: locale === 'en' ? 'blue' : 'white', color: locale === 'en' ? 'white' : 'black' }}
          onClick={() => switchLng('en')}
        >
          en
        </Button>
        <Button
          style={{ backgroundColor: locale === 'nl' ? 'blue' : 'white', color: locale === 'nl' ? 'white' : 'black' }}
          onClick={() => switchLng('nl')}
        >
          nl
        </Button>
        <Button
          style={{ backgroundColor: locale === 'fr' ? 'blue' : 'white', color: locale === 'fr' ? 'white' : 'black' }}
          onClick={() => switchLng('fr')}
        >
          fr
        </Button>
        <Button
          style={{ backgroundColor: locale === 'es' ? 'blue' : 'white', color: locale === 'es' ? 'white' : 'black' }}
          onClick={() => switchLng('es')}
        >
          es
        </Button>
        <Button
          style={{ backgroundColor: locale === 'da' ? 'blue' : 'white', color: locale === 'da' ? 'white' : 'black' }}
          onClick={() => switchLng('da')}
        >
          da
        </Button>
        <Button
          style={{ backgroundColor: locale === 'it' ? 'blue' : 'white', color: locale === 'it' ? 'white' : 'black' }}
          onClick={() => switchLng('it')}
        >
          it
        </Button>
        <Button
          style={{ backgroundColor: locale === 'ro' ? 'blue' : 'white', color: locale === 'ro' ? 'white' : 'black' }}
          onClick={() => switchLng('ro')}
        >
          ro
        </Button>
        <Button
          style={{ backgroundColor: locale === 'de' ? 'blue' : 'white', color: locale === 'de' ? 'white' : 'black' }}
          onClick={() => switchLng('de')}
        >
          de
        </Button>
        <Button
          style={{ backgroundColor: locale === 'no' ? 'blue' : 'white', color: locale === 'no' ? 'white' : 'black' }}
          onClick={() => switchLng('no')}
        >
          no
        </Button>
      </div>
    </div>
  )
}

export default translate(connect(undefined, { changeLocale: changeLocaleAction })(LocaleSwitcher))
